import React, { PureComponent } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import Checkbox from '../../../common/Checkbox';
import { withComponentId } from '../../../common/ComponentIdContext';
import ConstCommon from '../../../common/Const';
import { Search as SearchAdd } from '../../../common/mix-search';
import {
  addCompare,
  changeFilterIndustry,
  REDUCER_NAME,
  removeCompare,
} from '../reducer';
import CurrentState from '../../../helpers/CurrentState';
import { ConfirmPopup } from '../../../common/popup';

const MAX_TICKER_COMPARE = 5;

class Compare extends PureComponent {
  state = {
    isShowWarning: false,
    titleKey: '',
    message: '',
  };

  componentDidUpdate(prevProps) {
    const { compares, componentId } = this.props;
    if (compares !== prevProps.compares) {
      CurrentState.add(
        ConstCommon.listComponent.FinancialAnalysis,
        'compares',
        compares,
        componentId,
      );
    }
  }

  resetState = () => {
    this.setState({
      isShowWarning: false,
      titleKey: '',
      message: '',
    });
  };

  clickItemSearch = organization => {
    if (!organization) {
      return;
    }
    const { addCompare, compares, componentId, searchParams } = this.props;
    if (compares.length === MAX_TICKER_COMPARE) {
      this.setState({
        isShowWarning: true,
        titleKey: 'message.cannotAddTickerCompare',
        message: I18n.t('message.cannotAddTickerCompareMessage'),
      });
      return;
    }
    const isExist = compares.some(
      item => item.organCode === organization.organCode,
    );
    const isNotSameType = searchParams.isBanking !== organization.isBanking;
    const isSearchParam = searchParams.code === organization.code;
    if (isNotSameType || isExist || isSearchParam) {
      this.setState({
        isShowWarning: true,
        titleKey: 'message.cannotCompare',
        message: I18n.t('message.cannotCompareMessage'),
      });
      return;
    }
    addCompare({ organization, componentId });
  };

  removeTicker = organCode => {
    const { removeCompare, componentId } = this.props;
    removeCompare({ organCode, componentId });
  };

  onCheckBoxChange = e => {
    const { changeFilterIndustry, componentId } = this.props;
    changeFilterIndustry({ checked: e.target.checked, componentId });
  };

  getIndustryName = () => {
    const { companyScore, listIndustryByIcbCode } = this.props;
    const industry = listIndustryByIcbCode[companyScore.icbCode];

    return industry ? industry.icbName : '--';
  };

  render() {
    const { isShowWarning, titleKey, message } = this.state;
    const { listSearch, compares, isFilterIndustry } = this.props;
    this.getIndustryName();
    return (
      <div className="compare">
        <ConfirmPopup
          title={titleKey}
          messages={[message]}
          isShow={isShowWarning}
          confirm={() => this.setState({ isShowWarning: false })}
          enabledApply={false}
          enabledCancel={false}
          iconName={'icon-warning'}
        />
        <div className="search-box d-flex align-items-center">
          <div className="label mr-12">
            <Translate value="financialAnalysis.financialRatio.compareTo" />
          </div>
          <SearchAdd
            isClear
            listSearch={listSearch}
            listKeyFilter={[
              ConstCommon.listOrganization.TICKER,
              ConstCommon.listOrganization.ORGAN_SHORT_NAME,
            ]}
            clickItemSearch={this.clickItemSearch}
            mainKey="organCode"
            sortKey="ticker"
          />

          <div className="is-industry">
            <Checkbox
              labelTitle={this.getIndustryName()}
              isChecked={isFilterIndustry}
              onChange={this.onCheckBoxChange}
              label={I18n.t('financialAnalysis.financialRatio.industry')}
            />
          </div>
        </div>

        <div className="tickers d-flex">
          <div
            className="ticker"
            style={{
              visibility: 'hidden',
              maxWidth: '1px',
              marginLeft: 0,
              padding: 0,
            }}
          >
            p
          </div>
          {compares.map(org => (
            <div key={org.organCode} className="ticker">
              {org.displayCode}
              <i
                onClick={() => this.removeTicker(org.organCode)}
                className="icon-close"
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => ({
  listSearch: state[COMMON_REDUCER_NAME].listOrganizationSearch,
  compares: state[REDUCER_NAME][componentId].compares,
  isFilterIndustry: state[REDUCER_NAME][componentId].isFilterIndustry,
  searchParams: state[REDUCER_NAME][componentId].searchParams,
  companyScore: state[REDUCER_NAME][componentId].companyScore,
  listIndustryByIcbCode: state[COMMON_REDUCER_NAME].listIndustryByIcbCode,
});

const mapDispatchToProps = {
  addCompare,
  removeCompare,
  changeFilterIndustry,
};

Compare.propTypes = {};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Compare);
